function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 17.625H17.5V14.25H19.75V17.625V19.875H4V17.625ZM4 14.25H6.25V17.625H4V14.25ZM9.625 3H14.125V10.875H16.375L11.875 16.5L7.375 10.875H9.625V3Z",
  fill: "#00BBFF"
});
const SvgSave = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/save.2646b145.svg";
export { ForwardRef as ReactComponent };